import { CarouselButtons, Stack, XStack, useCarousel } from '@my/ui'
import { H3 } from 'app/components'
import { CollectionGridItem } from './collection-grid-item'
import { CollectionGridComponentProps } from './collection-grid.component'

export const CollectionGridComponent = (props: CollectionGridComponentProps) => {
  const carousel = useCarousel()

  return (
    <Stack my="$4">
      <H3 pb="$4">{props.collectionGridHeading}</H3>
      <Stack position="relative" overflow="hidden" w="100%" ref={carousel.emblaRef as any} pb="$4">
        <XStack gap="$3.5" height="auto">
          {props.offers &&
            props.offers.map((item) => (
              <Stack key={item.id} w={150} h={200} $gtXs={{ w: 270, h: 390 }}>
                <CollectionGridItem {...item} imagePriority={props.imagePriority} />
              </Stack>
            ))}
        </XStack>
        <CarouselButtons carousel={carousel} />
      </Stack>
    </Stack>
  )
}
